export default "__VITE_ASSET__BuyOBc8T__"